function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 25,
  fill: "#B7B7B7"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: -555,
  y: -328,
  width: 770,
  height: 397,
  rx: 8,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4034_11041)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.46779 25C3.28309 24.9984 2.14742 24.5248 1.30999 23.6832C0.472566 22.8416 0.00179248 21.7008 0.000976562 20.511V5.09209C0.00260878 3.90284 0.473743 2.76278 1.31108 1.92185C2.14842 1.08093 3.28362 0.607779 4.46779 0.60614H17.6616C18.0109 0.60614 18.3459 0.745512 18.593 0.993597C18.84 1.24168 18.9788 1.57815 18.9788 1.929C18.9788 2.27984 18.84 2.61632 18.593 2.8644C18.3459 3.11249 18.0109 3.25186 17.6616 3.25186H4.46779C3.98331 3.2567 3.52003 3.45214 3.17743 3.7962C2.83483 4.14027 2.64023 4.60553 2.63541 5.09209V20.511C2.63539 21.0008 2.82785 21.4708 3.17096 21.8188C3.51408 22.1669 3.98012 22.3649 4.46779 22.3698H19.8209C20.3118 22.3698 20.7826 22.174 21.1297 21.8254C21.4768 21.4768 21.6718 21.004 21.6718 20.511V9.84137C21.6632 9.66247 21.6908 9.48367 21.753 9.31582C21.8153 9.14797 21.9108 8.99455 22.0338 8.86488C22.1568 8.7352 22.3048 8.63196 22.4687 8.56142C22.6327 8.49088 22.8091 8.45451 22.9875 8.45451C23.1658 8.45451 23.3423 8.49088 23.5063 8.56142C23.6702 8.63196 23.8181 8.7352 23.9412 8.86488C24.0642 8.99455 24.1597 9.14797 24.2219 9.31582C24.2842 9.48367 24.3118 9.66247 24.3032 9.84137V20.511C24.3028 21.1014 24.1865 21.686 23.9609 22.2313C23.7354 22.7765 23.405 23.2718 22.9887 23.6887C22.5724 24.1056 22.0783 24.436 21.5348 24.6611C20.9912 24.8861 20.4088 25.0013 19.8209 25H4.46779Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.3626 -2.36488C28.1619 -2.56721 27.9235 -2.72775 27.6609 -2.8373C27.3984 -2.94684 27.1168 -3.00323 26.8325 -3.00323C26.5482 -3.00323 26.2666 -2.94684 26.0041 -2.8373C25.7415 -2.72775 25.5031 -2.56721 25.3024 -2.36488L13.3117 9.68027C13.217 9.77287 13.1341 9.87693 13.065 9.99007L11.4146 13.7387C11.3673 13.8459 11.3474 13.9632 11.3567 14.0801C11.3661 14.197 11.4044 14.3096 11.4682 14.4078C11.5319 14.506 11.6191 14.5867 11.7218 14.6424C11.8245 14.6981 11.9395 14.7272 12.0562 14.727C12.1539 14.7272 12.2505 14.7071 12.34 14.6681L16.0696 12.9983C16.1812 12.9285 16.2846 12.8464 16.3781 12.7535L28.3626 0.711468C28.5645 0.509921 28.7248 0.270262 28.8341 0.00628161C28.9435 -0.257699 28.9998 -0.540791 28.9998 -0.826705C28.9998 -1.11262 28.9435 -1.39571 28.8341 -1.65969C28.7248 -1.92367 28.5645 -2.16333 28.3626 -2.36488Z",
  fill: "#C4C4C4"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4034_11041"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 28,
  fill: "white",
  transform: "translate(0 -3)"
})));

function SvgIcChangeReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChangeReview);
export default __webpack_public_path__ + "static/media/ic_change_review.d89784cf.svg";
export { ForwardRef as ReactComponent };